import { BASE_URL } from "@/constants/endpoints";
import { MotivoInList } from "@/pages/config/motives/schema/motives.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let motivesApiPromise: Promise<AxiosInstance> | null = null;

const getMotivesApi = async (): Promise<AxiosInstance | null> => {
  if (motivesApiPromise) return motivesApiPromise;
  motivesApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return motivesApiPromise;
};

export const getAllMotivos = async (): Promise<
  MotivoInList[] | undefined | null
> => {
  const api = await getMotivesApi();

  if (!api) return;

  const response = await api.get("/Motivos/GetListadoMotivos");

  return response.data;
};

export interface GetMotivoProps {
  idMotivo: number;
}

export const getDetalleMotivo = async (props: GetMotivoProps) => {
  const api = await getMotivesApi();

  if (!api) return;

  const response = await api.get(
    `/Motivos/GetDetalleMotivo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateMotiveProps {
  descripcion: string;
  tiposMotivo: string[];
  idsTipoSolicitud: number[];
}

export const createMotive = async (props: CreateMotiveProps) => {
  const api = await getMotivesApi();

  if (!api) return;

  const response = await api.post(
    `/Motivos/CrearMotivo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateMotiveProps {
  id: number;
  descripcion: string;
  tiposMotivo: string[];
  idsTipoSolicitud: number[];
}

export const updateMotive = async (props: UpdateMotiveProps) => {
  const api = await getMotivesApi();

  if (!api) return;

  const response = await api.put(
    `/Motivos/EditarMotivo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface DeleteMotiveProps {
  idMotivos: number[];
}

export const deleteMotives = async (props: DeleteMotiveProps) => {
  const api = await getMotivesApi();

  if (!api) return;

  const response = await api.delete(
    `/Motivos/EliminarMotivo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};
